// English translations for the admin-users area, keyed by the Russian source string.
export default {
  // Sub-menus / page
  'Пользователи': 'Users',
  'Список отправителей': 'Senders list',
  'Список получателей': 'Receivers list',
  'Список сотрудников': 'Staff list',
  'Поиск': 'Search',
  'Добавить отправителя': 'Add sender',
  'Добавить получателя': 'Add receiver',
  'Добавить сотрудника': 'Add staff',

  // Table columns / cards
  'Имя': 'First name',
  'Фамилия': 'Last name',
  'Логин': 'Username',
  'Телефон': 'Phone',
  'Электронная почта': 'Email',
  'Адрес': 'Address',
  'Роль': 'Role',
  'Принтер': 'Printer',
  'Действие': 'Action',
  'Нет данных': 'No data',
  'Есть доступ ко входу': 'Has login access',

  // Details page
  'Назад': 'Back',
  'Изменить ПИН-код': 'Change PIN code',
  'Зарегистрировать отправителя': 'Register sender',
  'Зарегистрировать получателя': 'Register receiver',

  // Common actions
  'Сохранить': 'Save',
  'Добавить': 'Add',
  'Удалить': 'Delete',
  'Отмена': 'Cancel',
  'Изменить': 'Change',
  'Загрузка...': 'Loading...',

  // Staff modal
  'Данные сотрудника': 'Staff details',
  'Данные сотрудника успешно изменены!': 'Staff details updated successfully!',
  'Сотрудник успешно зарегистрирован!': 'Staff registered successfully!',
  'Введите логин пользователя!': 'Enter the username!',
  'Логин может содержать только латинские буквы, цифры, точку, нижнее подчёркивание и дефис!':
    'Username may contain only Latin letters, digits, period, underscore and hyphen!',
  'Роль': 'Role',
  'Выберите роль!': 'Select a role!',
  'Администратор': 'Administrator',
  'Менеджер': 'Manager',
  'Владелец': 'Owner',
  'IP-адрес принтера': 'Printer IP address',

  // Client (sender/receiver) modal
  'Данные отправителя': 'Sender details',
  'Данные получателя': 'Receiver details',
  'Данные отправителя успешно изменены!': 'Sender details updated successfully!',
  'Отправитель успешно зарегистрирован!': 'Sender registered successfully!',
  'Данные получателя успешно изменены!': 'Receiver details updated successfully!',
  'Получатель успешно зарегистрирован!': 'Receiver registered successfully!',
  'Удаление отправителя!': 'Delete sender!',
  'Удаление получателя!': 'Delete receiver!',
  'Вы собираетесь удалить данные отправителя. Продолжить?': 'You are about to delete the sender data. Continue?',
  'Вы собираетесь удалить данные получателя. Продолжить?': 'You are about to delete the receiver data. Continue?',
  'Отправитель успешно удалён!': 'Sender deleted successfully!',
  'Получатель успешно удалён!': 'Receiver deleted successfully!',
  'Страна': 'Country',
  'Выберите страну!': 'Select a country!',
  'Отправитель': 'Sender',
  'Выберите учётную запись отправителя!': 'Select the sender account!',
  'Тип': 'Type',
  'Тип отправителя': 'Sender type',
  'Тип получателя': 'Receiver type',
  'Физическое лицо': 'Individual',
  'Организация': 'Organization',
  'Введите название организации!': 'Enter the organization name!',
  'Введите имя!': 'Enter the first name!',
  'Введите фамилию!': 'Enter the last name!',
  'Введите номер телефона!': 'Enter the phone number!',
  'Введите адрес в правильном формате!': 'Enter the address in the correct format!',
  'Введите адрес!': 'Enter the address!',
  'Адрес организации': 'Organization address',
  'Домашний адрес': 'Home address',
  'Город/Область': 'City/Province',
  'Укажите город/область!': 'Specify the city/province!',
  'Район/Сомон': 'District/Soum',
  'Укажите район/сомон!': 'Specify the district/soum!',
  'Укажите хороо/баг!': 'Specify the khoroo/bag!',
  'Дом/квартира': 'House/Apartment',

  // PIN code
  'ПИН-код': 'PIN code',
  'Введите ПИН-код!': 'Enter the PIN code!',
  'ПИН-код должен состоять из 6 цифр': 'The PIN code must be 6 digits',
  'ПИН-код успешно изменён!': 'PIN code changed successfully!',
  'Новый ПИН-код': 'New PIN code',
  'Введите новый ПИН-код!': 'Enter the new PIN code!',
  'Повторите ПИН-код': 'Repeat PIN code',
  'Повторите ПИН-код!': 'Repeat the PIN code!',
  'Введённые ПИН-коды не совпадают!': 'The entered PIN codes do not match!',
  'Удаление сотрудника!': 'Delete staff member!',
  'Сотрудник потеряет доступ к системе. Продолжить?': 'The staff member will lose access to the system. Continue?',
  'Сотрудник удалён': 'Staff member deleted',
  'Не удалось удалить сотрудника': 'Failed to delete staff member',
}
